import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/diagramms/pythonDiagram.css";
import { useLanguage } from "context/LanguageProvider";
import { stagesNames } from "components/translation.js";
import { useDarkMode } from "../../context/DarkModeProvider";

function PythonDiagram({ finalStages = [], substructureName = "" }) {
  const navigate = useNavigate();
  const { selLanguage } = useLanguage();
  const [activeId, setActiveId] = useState(null);

  const { darkMode } = useDarkMode();

  const handleClick = (stage) => {
    setActiveId(stage.id);
    localStorage.setItem("stageLocation", stage.name);
    localStorage.setItem("selectedStageId", stage.id);
    navigate("/admin/index");
  };

  const total = finalStages.length;

  return (
    <div className="py-explorer-wrap" style={{ background: darkMode ? "var(--color-background-secondary, #1e1e2e)" : "#e7e7e79a" }}>
      <div className="py-folder-row">
        <span className="py-folder-icon">▾</span>
        <span className="py-folder-label">PYTHON{substructureName ? ` / ${substructureName}` : ""}</span>
      </div>

      <div className="py-file-list">
        {finalStages.map((stage, i) => {
          const isLast = i === total - 1;
          const prefix = isLast ? "└── " : "├── ";

          const normalizedName = stage.name.toLowerCase().trim();
          const baseName = selLanguage
            ? (stagesNames[normalizedName] ?? stage.name)
            : stage.name;
          const displayLabel = `${baseName}.py`;
          const isActive = activeId === stage.id;

          return (
            <div key={stage.id} className="py-file-item">
              <span className="py-tree-prefix">{prefix}</span>
              <button
                className={`py-file-btn${isActive ? " py-file-btn--active" : ""}`}
                onClick={() => handleClick(stage)}
                title={displayLabel}
                style={{ color: darkMode ? "#fff" : "#0d0c0cac" }}
              >
                <span className="py-icon">py</span>
                <span className="py-file-name">{displayLabel}</span>
                <span className="py-stage-num">{i + 1}/{total}</span>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default PythonDiagram;